import { cookieManager } from "@/service/cookieManager";

class MercureRepository {
	constructor() {
		const host = window.location.hostname;
		if (host === "localhost" || host.startsWith("192.168")) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL;
		} else {
			this.urlBase = window.location.origin;
		}
	}

	async subscribe(payload) {
		const url = `${this.urlBase}/world/api/mercure/subscribe`;
		const token = cookieManager.getToken();

		const options = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			credentials: "include",
			body: JSON.stringify(payload),
		};

		if (token) {
			options.headers.Authorization = `Bearer ${token}`;
		}

		const response = await fetch(url, options);
		if (response.status === 401) {
			throw new Error("Mercure subscribe unauthorized (401)");
		}
		if (!response.ok) {
			throw new Error(`Mercure subscribe failed: ${response.status}`);
		}

		return response.json();
	}
}

export const mercureRepository = new MercureRepository();

export default mercureRepository;
